import CenterApp from "./CenterApp";
import { bootstrapApp } from "./bootstrap";

bootstrapApp("PenumbraOS Center", <CenterApp />);
